exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".provider-panel--1hLPCD_asa2NYt3kOEOt_A {\n  margin-left: auto;\n}\n", ""]);

// exports
exports.locals = {
	"activePatientsContainer": "provider-panel--1hLPCD_asa2NYt3kOEOt_A",
	"activePatientsContainer": "provider-panel--1hLPCD_asa2NYt3kOEOt_A"
};